// // AuthContext.js - COMPLETE FIX
// import React, { createContext, useState, useContext, useEffect } from 'react';
// import { useGoogleAuth } from './GoogleAuthContext';

// const AuthContext = createContext();

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const { user: googleUser, logout: googleLogout } = useGoogleAuth();

//   // Sync Google user with auth context and check existing auth
//   useEffect(() => {
//     const checkAuth = async () => {
//       const storedUser = localStorage.getItem('user');
//       const googleUserData = localStorage.getItem('google_user');
      
//       console.log('🔄 AuthContext: Checking authentication state');
      
//       // Priority: Regular auth > Google auth
//       if (storedUser) {
//         const userData = JSON.parse(storedUser);
//         console.log('✅ Setting regular user:', userData.email);
//         setUser(userData);
//       } else if (googleUserData) {
//         const googleData = JSON.parse(googleUserData);
//         console.log('✅ Setting Google user:', googleData.email);
//         setUser({
//           id: googleData.id,
//           email: googleData.email,
//           name: googleData.name,
//           picture: googleData.picture,
//           provider: 'google'
//         });
//       } else {
//         console.log('❌ No user found in storage');
//       }
      
//       setLoading(false);
//     };

//     checkAuth();
//   }, [googleUser]);

//   // Register user
//   const register = async (userData) => {
//     try {
//       console.log('📝 AuthContext: Sending registration data');
      
//       const backendData = {
//         full_name: userData.fullName,
//         email: userData.email,
//         phone: userData.phone,
//         password: userData.password,
//         location: userData.location
//       };

//       const response = await fetch('https://krishidnya-backend.onrender.com/api/auth/register', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(backendData),
//       });

//       console.log('📨 AuthContext: Registration response status:', response.status);

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error('❌ AuthContext: Registration failed:', errorData);
//         return {
//           success: false,
//           message: errorData.message || 'Registration failed'
//         };
//       }

//       const data = await response.json();
//       console.log('✅ AuthContext: Registration successful');
      
//       if (data.success) {
//         setUser(data.data.user);
//         localStorage.setItem('user', JSON.stringify(data.data.user));
//         localStorage.setItem('token', data.data.token);
//         localStorage.setItem('token_timestamp', Date.now().toString());
//       }
      
//       return data;
//     } catch (error) {
//       console.error('❌ AuthContext: Registration network error:', error);
//       return {
//         success: false,
//         message: 'Registration failed. Please check if the server is running.'
//       };
//     }
//   };

//   // Login user
//   const login = async (credentials) => {
//     try {
//       console.log('🔐 AuthContext: Sending login data');
      
//       const response = await fetch('https://krishidnya-backend.onrender.com/api/auth/login', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(credentials),
//       });

//       console.log('📨 AuthContext: Login response status:', response.status);

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error('❌ AuthContext: Login failed:', errorData);
//         return {
//           success: false,
//           message: errorData.message || 'Login failed'
//         };
//       }

//       const data = await response.json();
//       console.log('✅ AuthContext: Login successful - User:', data.data.user?.email);
      
//       if (data.success) {
//         setUser(data.data.user);
//         localStorage.setItem('user', JSON.stringify(data.data.user));
//         localStorage.setItem('token', data.data.token);
//         localStorage.setItem('token_timestamp', Date.now().toString());
//       }
      
//       return data;
//     } catch (error) {
//       console.error('❌ AuthContext: Login network error:', error);
//       return {
//         success: false,
//         message: 'Login failed. Please check if the server is running.'
//       };
//     }
//   };

//   // Logout user - FIXED
//   const logout = () => {
//     console.log('🚪 AuthContext: Logout triggered');
    
//     setUser(null);
//     // Clear ALL storage to prevent conflicts
//     localStorage.removeItem('user');
//     localStorage.removeItem('token');
//     localStorage.removeItem('token_timestamp');
//     localStorage.removeItem('google_user');
//     localStorage.removeItem('cart'); // Remove any cart data
//     localStorage.removeItem('userCart'); // Remove CartContext data
    
//     console.log('✅ AuthContext: Logout completed');
    
//     // Also logout from Google if user was logged in with Google
//     if (user?.provider === 'google') {
//       console.log('🔐 Also logging out from Google');
//       googleLogout();
//     }
//   };

//   const value = {
//     user,
//     loading,
//     register,
//     login,
//     logout,
//     isAuthenticated: !!user
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContext;
// AuthContext.js - COMPLETE FIX with Google OAuth Support
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useGoogleAuth } from './GoogleAuthContext';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user: googleUser, logout: googleLogout } = useGoogleAuth();

  // Sync Google user with auth context and check existing auth
  useEffect(() => {
    const checkAuth = async () => {
      const storedUser = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      
      console.log('🔄 AuthContext: Checking authentication state');
      
      if (storedUser && token) {
        try {
          const userData = JSON.parse(storedUser);
          console.log('✅ Setting user from storage:', userData.email);
          setUser(userData);
        } catch (error) {
          console.error('Error parsing user data:', error);
          localStorage.removeItem('user');
          localStorage.removeItem('token');
        }
      } else {
        console.log('❌ No user found in storage');
      }
      
      setLoading(false);
    };

    checkAuth();
  }, [googleUser]);

  // Register user
  const register = async (userData) => {
    try {
      console.log('📝 AuthContext: Sending registration data');
      
      const backendData = {
        full_name: userData.fullName,
        email: userData.email,
        phone: userData.phone,
        password: userData.password,
        location: userData.location
      };

      const response = await fetch('https://krishidnya-backend.onrender.com/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(backendData),
      });

      console.log('📨 AuthContext: Registration response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('❌ AuthContext: Registration failed:', errorData);
        return {
          success: false,
          message: errorData.message || 'Registration failed'
        };
      }

      const data = await response.json();
      console.log('✅ AuthContext: Registration successful');
      
      if (data.success) {
        setUser(data.data.user);
        localStorage.setItem('user', JSON.stringify(data.data.user));
        localStorage.setItem('token', data.data.token);
        localStorage.setItem('token_timestamp', Date.now().toString());
      }
      
      return data;
    } catch (error) {
      console.error('❌ AuthContext: Registration network error:', error);
      return {
        success: false,
        message: 'Registration failed. Please check your internet connection.'
      };
    }
  };

  // Login user
  const login = async (credentials) => {
    try {
      console.log('🔐 AuthContext: Sending login data for:', credentials.email);
      
      const response = await fetch('https://krishidnya-backend.onrender.com/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: credentials.email,
          password: credentials.password
        }),
      });

      console.log('📨 AuthContext: Login response status:', response.status);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('❌ AuthContext: Login failed:', errorData);
        return {
          success: false,
          message: errorData.message || 'Invalid email or password'
        };
      }

      const data = await response.json();
      console.log('✅ AuthContext: Login successful for:', data.data.user?.email);
      
      if (data.success) {
        setUser(data.data.user);
        localStorage.setItem('user', JSON.stringify(data.data.user));
        localStorage.setItem('token', data.data.token);
        localStorage.setItem('token_timestamp', Date.now().toString());
      }
      
      return data;
    } catch (error) {
      console.error('❌ AuthContext: Login network error:', error);
      return {
        success: false,
        message: 'Login failed. Please check your internet connection.'
      };
    }
  };

  // Google Login Handler - Called from components
  const googleLogin = async () => {
    try {
      console.log('🔐 AuthContext: Initiating Google login');
      // This will trigger the Google OAuth flow
      // The actual token handling is done in GoogleAuthContext
      return { success: true, redirecting: true };
    } catch (error) {
      console.error('❌ AuthContext: Google login error:', error);
      return {
        success: false,
        message: 'Google login failed. Please try again.'
      };
    }
  };

  // Logout user
  const logout = () => {
    console.log('🚪 AuthContext: Logout triggered');
    
    setUser(null);
    // Clear ALL storage to prevent conflicts
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('token_timestamp');
    localStorage.removeItem('google_token');
    localStorage.removeItem('google_user');
    localStorage.removeItem('cart');
    localStorage.removeItem('userCart');
    
    console.log('✅ AuthContext: Logout completed');
    
    // Also logout from Google if user was logged in with Google
    if (user?.provider === 'google') {
      console.log('🔐 Also logging out from Google');
      googleLogout();
    }
  };

  const value = {
    user,
    loading,
    register,
    login,
    googleLogin,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
